import styled from '@emotion/styled'

import { spacing } from 'main/ui'

export const HeadingContainer = styled.div`
  display: inline-flex;
  margin-bottom: ${spacing.majorScale(1)}px;

  > :not(:last-child) {
    margin-right: ${spacing.majorScale(1)}px;
  }
`
